import classNames from "classnames";
import { FC } from "react";
import styles from "./styles/FilterButton.module.scss";
import * as MainIcons from "../../../../libs/corporate/icons/outlined/action/MainCollection"

export interface IFilterButtonProps {
    nameButton: string
    isOpen: boolean
    onOpenChange:() => void
}
export interface IFilterButtonClearProps {
    nameButton: string
    isOpen: boolean
    onClick:() => void
}

export const FilterButton: FC<IFilterButtonProps> = (props) => {

    return <div className={classNames(styles.root, props.isOpen && styles.root_open)}>
        <button
            className={classNames(styles.button)}
            onClick={() => props.onOpenChange()}>
            <div className={styles.contentWrapper}>
                {props.nameButton}
            </div>
            <div className={styles.iconWrapper}>
            <MainIcons.FilterIcon/>
            </div>
        </button>
    </div>
}
export const FilterClearButton: FC<IFilterButtonClearProps> = (props) => {

    return <div className={classNames(styles.root, props.isOpen && styles.root_open)}>
        <button
            className={classNames(styles.button)}
            onClick={() => props.onClick()}>
                <div className={styles.contentWrapper}>
                    {props.nameButton}
                </div>

                <div className={styles.iconWrapper}>
                    <MainIcons.FilterClearIcon/>
                </div>
        </button>
    </div>
}